export default {"src":"/_next/static/media/layers.86e77e2b.svg","height":24,"width":24};